/*
 * @Author: Girish Akhare
 * @Date: 2021-02-08 10:30:15
 * @Last Modified by: Girish Akhare
 * @Last Modified time: 2022-10-06 20:13:20
 */

export const _FS = '/';

export const HOME = 'chart'; //TODO: Set this to '/dashboard' later.
export const PHISHING = 'phishing';
export const SAT = 'sat';
export const CONFIG = 'config';
export const MANAGE_DEVICES = 'manage-devices';
export const PASSWORD_POLICY = 'password-policy';
export const DOWNLOAD_APPLET = 'download-applet';
export const RELEASE_NOTES = 'release-notes';
export const DEVICE_MIGRATION_DASHBOARD = 'device-migration-dashboard';
export const SUPPORT = 'support';
export const REPORTS = 'reports';
export const CYBER_SECURITY_POLICY = 'cyber-policy';
export const FAILING_FACTORS_REPORT = 'failing-factors';
export const BROKER_DEALER = 'manage-account';
export const DEVICE_SYSTEM_LOGS = 'device-system-logs';
export const MY_REPORTS = 'my-reports';

export const AUTH = 'auth';
export const AUTH_LOGIN = 'login';
export const AUTH_VERIFY_USER = 'verify-user';
export const AUTH_VERIFY_OTP = 'verify-otp';
export const AUTH_RESET_PASSWORD = 'reset-password';
export const AUTH_LOGIN_OTP = 'passcode';

export const USERS = 'users';
export const CHART = 'chart';
export const REPORT = 'report';
export const COMPLIANCE = 'compliance';
export const DASHBOARD = 'dashboard';
export const RESTRICTED_APPLICATIONS_AND_PROCESSES =
  'restricted-applications-and-processes';
export const ADD_USER = 'add-user';
export const EDIT_USER = 'edit-user';
export const ALERT_AND_NOTIFICATION = 'alert-notification';
export const HISTORIC_SAT = 'historic-sat';
export const HISTORIC_PHISHING = 'historic-phishing';
export const ANALYTICS = 'analytics';
export const OLD_PHISHING = 'old-phishing';
export const APPS = 'apps';
export const ACCESS_DENIED = '403';

export function callEditUserRoute(junctionId: string) {
  return [USERS, EDIT_USER, junctionId].join(_FS);
}

export const ADD_USER_ROUTE = [USERS, ADD_USER].join(_FS);
export const CHART_REPORT = [CHART, REPORT].join(_FS);

export const VALIDATING_PORTAL = 'validatingPortal';

// End ROUTE for Entreda Tasks

// Portal ROUTES
export const PORTAL_WELCOME = '/welcome';
export const PORTAL_LOGOUT = '/user/logout';
export const NGP_LOGIN = '/auth/login';
// End of Portal ROUTES

// Page Titles of all compoenents
export class PageTitles {
  public static MANAGE_DEVICES = 'Manage Devices';
  public static PASSWORD_POLICY = 'Password Policy';
  public static DOWNLOAD_APPLET = 'Download Applet';
  public static ANALYTICS = 'Analytics';
  public static RAD = 'Risk Analytics Dashboard';
  public static UM = 'Manage Users';
  public static IP = 'Installation Password';
  public static EB = 'Endpoint Backup';
  public static EB_CONFIG = 'Config';
  public static EB_SUMMARY = 'Summary';
  public static ENROLL = 'Enroll';
  public static PHISHING_SIMULATION_TESTS = 'Phishing Simulation Tests';
  public static PHISHING_SUMMARY = 'Phishing Summary';
  public static PHISHING_DETAILS = 'Phishing Details';
  public static SAT = 'Security Awareness Training';
  public static SAT_SUMMARY = 'SAT Summary';
  public static SAT_DETAILS = 'SAT Details';
  public static HISTORIC_SAT = 'Historic Security Awareness Training';
  public static HISTORIC_SAT_SUMMARY = 'Historic SAT Summary';
  public static HISTORIC_SAT_DETAILS = 'Historic SAT Details';
  public static RELEASE_NOTES = 'Release Notes';
  public static COMPLIANCE = 'Compliance';
  public static DASHBOARD = 'Dashboard';
  public static COMPLIANCE_DETAILS = 'Device Compliance Details';
  public static SUPPORT = 'Support';
  public static ALERT_AND_NOTIFICATION = 'Alerts & Notification';
  public static MY_REPORTS = 'My Reports';
  public static FAILING_FACTORS = 'Failing Factors';
  public static DEVICE_SYSTEM_LOGS = 'Device System Logs';
  public static CYBER_SECURITY_POLICY = 'Cybersecurity Policy';
  public static HISTORIC_PHISHING_SIMULATION_TESTS =
    'Historic Phishing Simulation Tests';
  public static HISTORIC_PHISHING_SUMMARY = 'Historic Phishing Summary';
  public static HISTORIC_PHISHING_DETAILS = 'Historic Phishing Details';
  public static BROKER_DEALER = 'Manage Accounts';
  public static RESTRICTED_APPLICATIONS_AND_PROCESSES =
    'Restricted Applications And Processes';
  public static LOGIN = 'Login';
  public static OTP_LOGIN = 'Passcode Login';

  public static FORGOT_PASSWORD = 'Forgot Password';
  public static RESET_PASSWORD = 'Reset Password';
  public static VERIFY_OTP = 'Verify OTP';
  public static VERIFY_USER = 'Verify User';
  public static OLD_PORTAL = 'Return to Legacy Portal';
  public static NOT_FOUND = '404';
  public static APPS = 'Manage WebAuth Configuration';
  public static VIEW_APP = 'Application Details';
  public static APP_LOGIN_LOGS = 'Application Login Attempts';
  public static APP_AUDIT_LOGS = 'Application Audit Logs';
  public static REG_APP = 'Register Application';
  public static EDIT_APP = 'Edit Details';
  public static DEVICE_MIGRATION_DASHBOARD = 'Device Migration Dashboard';
  public static ACCESS_DENIED = '403';
}

export const PAGE_TITLE_PREFIX = 'Smarsh Cyber';
export const FOUR_MINUTES_IN_MS = 4 * 60 * 1000;

/**
 * Shared Api Paths
 */
export enum BFF_API_PATHS {
  RELEASE_NOTES_API = '/release-notes'
}

export const COMPLIANCE_PATHS = {
  BASE_URL: '/compliance',
  DETAILS: '/status',
  EXPORT_REPORT: '/export-grid-data'
};

export const IGNORE_HEADERS_FOR = [BFF_API_PATHS.RELEASE_NOTES_API];

export const isIgnoreHeaders = (url: string): boolean => {
  return IGNORE_HEADERS_FOR.some((path) => url.includes(path));
};
